/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Kind of the external account held at a third party for an ex-custody, ISA or SLB portfolio.
 * @export
 */
export const PortfolioExternalAccountType = {
    Custodian: 'CUSTODIAN',
    Broker: 'BROKER'
} as const;
export type PortfolioExternalAccountType = typeof PortfolioExternalAccountType[keyof typeof PortfolioExternalAccountType];


export function instanceOfPortfolioExternalAccountType(value: any): boolean {
    for (const key in PortfolioExternalAccountType) {
        if (Object.prototype.hasOwnProperty.call(PortfolioExternalAccountType, key)) {
            if (PortfolioExternalAccountType[key as keyof typeof PortfolioExternalAccountType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioExternalAccountTypeFromJSON(json: any): PortfolioExternalAccountType {
    return PortfolioExternalAccountTypeFromJSONTyped(json, false);
}

export function PortfolioExternalAccountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioExternalAccountType {
    return json as PortfolioExternalAccountType;
}

export function PortfolioExternalAccountTypeToJSON(value?: PortfolioExternalAccountType | null): any {
    return value as any;
}

export function PortfolioExternalAccountTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioExternalAccountType {
    return value as PortfolioExternalAccountType;
}

